import { formatPhone } from '../../shared/phone';
import type { BuiltinAnswers, PublicEvent } from '../../shared/types';
import { formatUsDate, participantName, participantWard } from '../../shared/builtin';
import type { ComponentChildren } from 'preact';

export function AnswerSummary({ ev, b, onEdit, disabled }: { ev: PublicEvent; b: BuiltinAnswers; onEdit: (step: number) => void; disabled?: boolean }) {
  const yesNo = (v: boolean | null, detail?: string) => v === true ? `Yes${detail?.trim() ? ` — ${detail}` : ''}` : v === false ? 'No' : 'Not answered';
  const card = (title: string, step: number, content: ComponentChildren) => <section class="reg-summary-card">
    <div class="row between"><h3>{title}</h3><button disabled={disabled} class="link" onClick={() => onEdit(step)} aria-label={`Edit ${title.toLowerCase()}`}>Edit</button></div>{content}
  </section>;
  const row = (label: string, answer: string) => <><dt>{label}</dt><dd>{answer || 'None provided'}</dd></>;
  return <div class="reg-summary">
    {card('Participant & contact', 1, <dl class="answers">
      {row('Participant', participantName(b))}{row('Ward', participantWard(ev, b))}{row('Date of birth', formatUsDate(b.dateOfBirth))}
      {row('Telephone', formatPhone(b.telephone))}{row('Address', `${b.address}, ${b.city}, ${b.stateOrProvince}`)}
      {row('Emergency contact', b.emergencyContact)}{row('Primary phone', formatPhone(b.emergencyPrimaryPhone))}{row('Secondary phone', formatPhone(b.emergencySecondaryPhone))}
    </dl>)}
    {card('Medical information', 2, <dl class="answers">
      {row('Special diet', yesNo(b.specialDiet, b.dietExplanation))}{row('Allergies', yesNo(b.allergies, b.allergyExplanation))}
      {row('Medications', b.medications)}{b.medications.trim() && row('Self-administers medication', yesNo(b.selfAdminister))}
    </dl>)}
    {card('Conditions that limit activity', 3, <dl class="answers">
      {row('Chronic or recurring illness', yesNo(b.chronicIllness, b.chronicIllnessExplanation))}
      {row('Surgery or serious illness in the past year', yesNo(b.surgery, b.surgeryExplanation))}
      {row('Other activity limitations', b.otherLimitations)}{row('Accommodations or special needs', b.specialNeeds)}
    </dl>)}
  </div>;
}
